import { ContainerComponent, wrap } from 'AppReact';
import { FullWidthFlexCenterWrapper } from 'wrappers';
import { BorderlessKeyInput } from 'atoms';
import Controller from './controller';
import internalState from './internalState';
import { Wrapper } from './wrappers';
import labelSwitch from './labelSwitch';
import { Button } from './atoms';

export const definition = {
  name: 'InputWithButton',
  initialProps: ({ value, label, buttonText, placeholder, buttonColor, disabledButton }) => ({ value, label, buttonText, placeholder, buttonColor, disabledButton }),
  props: internalState,
  controller: Controller,
  elements: [
    {
      wrapper: Wrapper,
      name: '__transparent__',
      elements: [
        {
          wrapper: FullWidthFlexCenterWrapper,
          name: 'Wrapper',
          elements: [
            {
              componentSelect: labelSwitch,
              name: 'Label',
              displayValue: ({ label }) => label?.values?.[0],
              renderIf: ({ label }) => label?.values?.length > 0,
              bindings: ({ label }) => {
                if (label.keys?.length > 0) {
                  const combinedValues = { ...label };
                  label.keys.forEach((key, index) => {
                    combinedValues[key] = label.values[index];
                  });
                  return combinedValues;
                }
                return label;
              }
            },
            {
              component: BorderlessKeyInput,
              name: 'Input',
              bindings: ({ value, placeholder, disabledButton }) => ({ disabled: disabledButton, value, placeholder: placeholder ?? "" })
            }
          ]
        },
        {
          component: Button,
          name: 'Button',
          displayValue: ({ buttonText }) => buttonText ?? 'Next',
          displayState: ({ buttonColor, disabledButton, value }) => ({ value, buttonColor, disabled: disabledButton }),
          bindings: ({ disabledButton, value }) => ({ value, disabled: disabledButton })
        }
      ]
    }
  ]
}

export default ContainerComponent(definition);